// src/app/modules/AccessControl/pages/components/QuickActionsModal.jsx
import React from "react";
import { Modal } from "react-bootstrap";
import { UserPlus, ShieldCheck, Home, Zap, ArrowRight } from 'lucide-react';
import './QuickActionsModal.scss';

export function QuickActionsModal({
  show,
  onHide,
  onGenerateCode,
  onStaffCheckIn,
  onResidentAccess,
  hasFeature,
  getLabel,
}) {
  function handle(fn) {
    onHide();
    fn();
  }

  return (
    <Modal show={show} onHide={onHide} centered className="quick-actions-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="qa-header-icon"><Zap size={14} /></span>
          Quick Actions
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="qa-grid">

          {/* Generate Visitor Code */}
          <button
            className="qa-item qa-item--visitor"
            onClick={() => handle(onGenerateCode)}
          >
            <div className="qa-item__icon"><UserPlus size={18} /></div>
            <div className="qa-item__content">
              <h4>Generate {getLabel('visitor')} Code</h4>
              <p>Create a one-time access code for a new visitor</p>
            </div>
            <ArrowRight size={15} className="qa-item__arrow" />
          </button>

          {/* Staff Check-In */}
          {hasFeature('hasStaff') && (
            <button
              className="qa-item qa-item--staff"
              onClick={() => handle(onStaffCheckIn)}
            >
              <div className="qa-item__icon"><ShieldCheck size={18} /></div>
              <div className="qa-item__content">
                <h4>{getLabel('staff')} Check-In</h4>
                <p>Clock in a staff member via QR or manual entry</p>
              </div>
              <ArrowRight size={15} className="qa-item__arrow" />
            </button>
          )}

          {/* Resident Access */}
          {hasFeature('hasResidents') && (
            <button
              className="qa-item qa-item--resident"
              onClick={() => handle(onResidentAccess)}
            >
              <div className="qa-item__icon"><Home size={18} /></div>
              <div className="qa-item__content">
                <h4>{getLabel('residents')} Access</h4>
                <p>Log a resident entry or exit event</p>
              </div>
              <ArrowRight size={15} className="qa-item__arrow" />
            </button>
          )}

        </div>
      </Modal.Body>

      <Modal.Footer>
        Select an action to continue
      </Modal.Footer>
    </Modal>
  );
}